export default __webpack_public_path__ + "static/smlogo-42e1c5c8db10a9b43aab9df0a7def16f.png";